import React from 'react';
import { Button, Icon, Form, Header, Segment, Loader, Table, Grid, Popup, Checkbox, Message } from 'semantic-ui-react';
import axios from 'axios';
import ReactExport from 'react-data-export';
import ReportExcelFile from '../StudentService/StudentsReports/ReportExcelFile';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class EmployeesByTypeAndGender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            report: null,
            orgUnit: null,
            orgUnits: [],
            excelData: [],
            disabled: false,
            employeeTypeId: null,
            allTypes: false,

            unsa: localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja' || localStorage.getItem('activeRole').substr(0, 13) === 'Administrator',

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    filter() {
        this.setState({ loaded: false });
        let obj = {
        };


        axios.get(this.state.organizationalUnitId === 0 ? `hr-reports/number-of-employees-by-gender/for-university/${this.state.employeeTypeId}/`
            : this.state.unsa ? `hr-reports/number-of-employees-by-gender/by-organizational-unit/${this.state.organizationalUnitId}/${this.state.employeeTypeId}/`
                : `hr-reports/number-of-employees-by-gender/${this.state.employeeTypeId}/`)
            .then(res => {
                console.log('res', res.data);
                this.setState({
                    data: res.data,
                    loaded: true,
                    excelData: res.data.map(el => ([
                        { value: el.name },
                        { value: el.numberOfEmployees },
                    ]))
                });
            });
    }


    render() {
        const multiDataSet = [
            {
                columns: [
                    { title: 'Spol', width: { wpx: 200 } },
                    { title: 'Broj zaposlenika', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];
        return (
            <div>

                <Form>
                    <Form.Group widths="equal">

                        {this.state.unsa && <Form.Field>
                            <label>Organizaciona jedinica</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite organizacionu jedinicu"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>}
                        <Form.Field>
                            <label>Tip osoblja</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite tip osoblja"
                                value={this.state.employeeTypeId}
                                onChange={this.handleInputChange}
                                name="employeeTypeId"
                                options={this.props.employeeTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        {!this.state.unsa && <Form.Field />}
                    </Form.Group>


                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj</Button>

                </Form>
                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ? <React.Fragment>
                            <Message>
                                Izvještaj uključuje samo zaposlenike odabranog tipa zaposlenja na matičnoj organizacionoj jedinici, sa aktivnim angažmanom i aktivnim PIO/MIO zapisom ili bez evidentiranog PIO/MIO zapisa. Ne uključuje angažovane saradnike, zaposlenike kojima je istekao angažman niti zaposlenike odjavljene sa PIO/MIO.
                            </Message>

                            <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={2}>
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14} />
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile
                                                    filename="Broj zaposlenika po spolu"
                                                    element={<Popup
                                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}
                                                >
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Zaposlenici" />
                                                </ExcelFile>

                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell >Spol</Table.HeaderCell>
                                    <Table.HeaderCell > Broj zaposlenika</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.state.data.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" > {el.name}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfEmployees}</Table.Cell>

                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        </React.Fragment> : 'Nema podataka.'}
                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/EmployeesByTypeAndGender.js